import styled from "styled-components";

export const Page = styled.main`
  min-height: 100%;
`;
